import { IDashRegistrationForTransplantedList, IRecipientForTransplantedList } from '@nkr/store/index';
import { IAliasOption, IDashOption } from '.';

export const transplantedUtility = {
    createAliasOption: (recipient: IRecipientForTransplantedList): IAliasOption => {
        let label = recipient.firstName != '' && recipient.lastName != '' ? `${recipient.firstName} ${recipient.lastName}, Alias: ${recipient.alias}, DOB: ${recipient.birthDate}, TXP Date: ${recipient.transplantDate}` : `Alias: ${recipient.alias}, DOB: ${recipient.birthDate}, TXP Date: ${recipient.transplantDate}`;
        return { ...recipient, label };
    },

    createDashOption: (registration: IDashRegistrationForTransplantedList): IDashOption => {
        let label = `${registration.firstName} ${registration.lastName}, DOB: ${registration.birthDate}${registration.isFromMicrosite ? ', Registered through microsite' : ''}`;
        return { ...registration, label };
    }
}